"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
require("./segmented-control.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * A pre-styled control that allows for multiple values in a tabbable-fashion (one selected at a time)
 */
var SegmentedControl = function SegmentedControl(_ref) {
  var visualStyle = _ref.visualStyle,
    inputs = _ref.inputs,
    onValueChange = _ref.onValueChange,
    className = _ref.className,
    selectedValue = _ref.selectedValue;
  var isDefault = visualStyle === 'default';
  var isDark = visualStyle === 'dark';
  var isInverted = visualStyle === 'inverted';
  var containerClasses = (0, _classnames["default"])('flex text-sm text-bold', 'sb-segmented-control--container', _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, className, Boolean(className)), 'color-greenAccent', isDefault), 'color-houseGreen', isDark), 'color-textWhite', isInverted));
  var segments = inputs.map(function (_ref2, index) {
    var value = _ref2.value,
      displayName = _ref2.displayName,
      iconPath = _ref2.iconPath;
    var isActive = value === selectedValue;
    return /*#__PURE__*/_react["default"].createElement("button", {
      "aria-pressed": value === selectedValue,
      className: (0, _classnames["default"])('flex-auto sb-segmented-control--segment', {
        'color-textWhite': isActive && !isInverted,
        'color-houseGreen': isActive && isInverted,
        'bg-greenAccent': isActive && isDefault,
        'bg-houseGreen': isActive && isDark,
        'bg-greenLight': isActive && isInverted
      }),
      key: index,
      onClick: function onClick(event) {
        event.preventDefault();
        onValueChange(value);
      }
    }, iconPath && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      className: "block mx-auto mb1",
      path: iconPath
    }), displayName);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerClasses
  }, segments);
};
SegmentedControl.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Controls the visual style of the component */
  visualStyle: _propTypes["default"].oneOf(['default', 'dark', 'inverted']),
  /** The inputs fields passed to the SegmentedControl. The number of inputs (objects) in the array determines the number of options shown within the SegmentedControl component. */
  inputs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /** The displayed text of the input */
    displayName: _propTypes["default"].string.isRequired,
    /** The value of the input */
    value: _propTypes["default"].string.isRequired,
    /** The path of the icon to be used */
    iconPath: _propTypes["default"].string
  })).isRequired,
  /** A function called when the selected value of the the SegmentedControl changes (when an individual control is clicked). This function receives the `value` defined in the `inputs` prop */
  onValueChange: _propTypes["default"].func.isRequired,
  /** The currently selected value--the selected value will be highlighted */
  selectedValue: _propTypes["default"].string,
  /** The classes applied to the container component */
  className: _propTypes["default"].string
} : {};
SegmentedControl.defaultProps = {
  visualStyle: 'default'
};
var _default = exports["default"] = SegmentedControl;